import { getGridLocalization } from '@material-ui/data-grid';
var ZH_TW = {
    // Root
    rootGridLabel: 'grid',
    noRowsLabel: '查無資料',
    errorOverlayDefaultLabel: 'An error occurred.',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: function (count) {
        return count !== 1 ? count + " active filters" : count + " active filter";
    },
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    // Columns panel text
    columnsPanelTextFieldLabel: 'Find column',
    columnsPanelTextFieldPlaceholder: 'Column title',
    columnsPanelDragIconLabel: 'Reorder column',
    columnsPanelShowAllButton: 'Show all',
    columnsPanelHideAllButton: 'Hide all',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelOperators: 'Operators',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorEquals: 'equals',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Show columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    // Column header text
    columnHeaderFiltersTooltipActive: function (count) {
        return count !== 1 ? count + " active filters" : count + " active filter";
    },
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: function (count) { return "\u5DF2\u9078\u64C7 " + count.toLocaleString() + " \u7B46"; },
    // Total rows footer text
    footerTotalRows: 'Total Rows:',
};
var ZH_TW_PAGE = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: '上一頁',
            labelRowsPerPage: '每頁筆數:',
            labelDisplayedRows: function labelDisplayedRows(_ref31) {
                var from = _ref31.from, to = _ref31.to, count = _ref31.count;
                return '第 '
                    .concat(String(from), ' 到 ')
                    .concat(String(to), ' 筆，總共  ')
                    .concat(count !== -1 ? count + " \u7B46" : "\u8D85\u904E " + to + " \u7B46");
            },
            nextIconButtonText: '下一頁',
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return ''
                    .concat(String(value), ' \u661F')
                    .concat(value !== 1 ? '星' : '');
            },
        },
        MuiAutocomplete: {
            clearText: '清除',
            closeText: '關閉',
            loadingText: '讀取中…',
            noOptionsText: '無選項',
            openText: '打開',
        },
        MuiAlert: {
            closeText: '關閉',
        },
    },
};
var zhTW = getGridLocalization(ZH_TW, ZH_TW_PAGE);
export default zhTW;
